import { Button, Modal } from "antd";
import caretLeftIcon from "assets/svg/chatFiles/CaretLeft.svg";
import caretRightIcon from "assets/svg/chatFiles/CaretRight.svg";
import closeIcon from "assets/svg/chatFiles/X.svg";
import { ChatFileMessage } from "context/adminContext";
import { formatMessageDateTime } from "helpers/format";

import styles from "./index.module.css";
import { useChatFileDownload } from "./useChatFileDownload";
import { formatMegabytes, getOriginalUrl, toUtc } from "./utils";

type Props = {
  images: ChatFileMessage[];
  // Индекс открытой картинки, null — модалка закрыта
  index: number | null;
  onIndexChange: (index: number) => void;
  onClose: () => void;
};

export const ChatImageModal = ({ images, index, onIndexChange, onClose }: Props) => {
  const image = index === null ? undefined : images[index];
  const { state, download } = useChatFileDownload(image);
  const hasNavigation = images.length > 1;

  return (
    <Modal
      open={Boolean(image)}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={714}
      classNames={{
        content: `${styles.modalContent} ${hasNavigation ? "" : styles.singleImageContent}`,
        body: styles.modalBody,
      }}
    >
      {image ? (
        <>
          <div className={styles.modalHeader}>
            <div className={styles.modalTitle}>Attached Images</div>
            <button type="button" className={styles.modalClose} onClick={onClose} aria-label="Close">
              <img src={closeIcon} alt="" />
            </button>
          </div>
          <div className={styles.modalMain}>
            <div className={styles.imageBox}>
              <img className={styles.modalImage} src={getOriginalUrl(image)} alt={image.content} />
            </div>
            <div className={styles.imageInfo}>
              <div className={styles.imageName}>{image.content}</div>
              <div className={styles.imageMeta}>
                {image.size ? (
                  <>
                    <span>{formatMegabytes(image.size)}MB</span>
                    <span className={styles.dot} />
                  </>
                ) : null}
                {image.createdAt ? <span>{formatMessageDateTime(toUtc(image.createdAt))}</span> : null}
              </div>
            </div>
            {hasNavigation ? (
              <div className={styles.navigation}>
                <button
                  type="button"
                  className={styles.navButton}
                  disabled={index === 0}
                  onClick={() => onIndexChange(index - 1)}
                >
                  <img src={caretLeftIcon} alt="" />
                </button>
                <div className={styles.stepper}>
                  {images.map((item, itemIndex) => (
                    <button
                      key={item.id}
                      type="button"
                      className={`${styles.step} ${itemIndex === index ? styles.activeStep : ""}`}
                      onClick={() => onIndexChange(itemIndex)}
                    />
                  ))}
                </div>
                <button
                  type="button"
                  className={styles.navButton}
                  disabled={index === images.length - 1}
                  onClick={() => onIndexChange(index + 1)}
                >
                  <img src={caretRightIcon} alt="" />
                </button>
              </div>
            ) : null}
          </div>
          <div className={styles.modalButtons}>
            <Button className={`${styles.modalButton} ${styles.closeButton}`} onClick={onClose}>
              Close
            </Button>
            <Button
              type="primary"
              className={`${styles.modalButton} ${styles.downloadButton}`}
              loading={state === "loading"}
              onClick={download}
            >
              Download
            </Button>
          </div>
        </>
      ) : null}
    </Modal>
  );
};
